import { render } from "./App.vue?vue&type=template&id=c3c8314e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/less/main.less?vue&type=style&index=0&lang=less"
import "@/assets/less/form.less?vue&type=style&index=1&lang=less"

import exportComponent from "/home/irina/projects/channel-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__